<template>
    <validation-observer class="form" ref="Addresses">
        <b-alert v-if="message.status == 'Error'" show variant="danger">
            <h4 class="alert-heading"> {{$t('general.error')}} </h4>
            <p> {{errMsg}} </p>
            <hr>
            <p class="mb-0"> {{message.message}} </p>
        </b-alert>
         <validation-provider :name="$t('defination.address.name')" :rules="{ required: true, min: 3 }" v-slot="validationContext">
            <b-form-group>
                <b-row> 
                    <b-col sm="4"> <label for="name"> {{$t('defination.address.name')}} </label> </b-col>
                    <b-col sm="8" class="multiItems">
                        <b-form-input
                            id="name"
                            v-model="name"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                            :placeholder="$t('defination.address.name')"
                        />
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-col>
                </b-row>
            </b-form-group>
        </validation-provider>

        <validation-provider v-if="data.type == 'country'" :name="$t('defination.address.code')" :rules="{ required: false, max:2}" v-slot="validationContext">
            <b-form-group>
                <b-row> 
                    <b-col sm="4"> <label for="code"> {{$t('defination.address.code')}} </label> </b-col>
                    <b-col sm="8" class="multiItems">
                        <b-form-input
                            id="code"
                            v-model="code"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                            :placeholder="$t('defination.address.code')"
                        />
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-col>
                </b-row>
            </b-form-group>
        </validation-provider>
        <validation-provider v-if="data.type !== 'town'" :name="$t('defination.address.prefix')" :rules="{ required: data.type == 'country', min: 3 }" v-slot="validationContext">
            <b-form-group>
                <b-row> 
                    <b-col sm="4"> <label for="prefix"> {{$t('defination.address.prefix')}} </label> </b-col>
                    <b-col sm="8" class="multiItems">
                        <b-form-input
                            id="prefix"
                            v-model="phone"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                            :placeholder="$t('defination.address.prefix')"
                        />
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-col>
                </b-row>
            </b-form-group>
        </validation-provider>
        
    </validation-observer>
</template>

<script>
import Vue from 'vue'
import i18n from '@/plugins/i18n';

    export default {
        name: "Address",
        data: function(){
            return{
                name: this.data ? this.data.name : "",
                code: this.data ? this.data.short_code : "",
                phone: this.data ? this.data.phone_code : "",
                errMsg: "",

            }
        },
        props:{
            data: Object,
            changeData: Function,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function,
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            clearForm(){
                this.code = ""
                this.name = ""
                this.phone_code = ""
                this.errMsg = ""
                this.modalEvent(false)

            }
        },
        computed:{
            message(){
                return this.$store.getters.getAddressStatus
            },
        },
        watch:{
            save: function(data){
                if(data){
                    let val = {
                        binary_code: this.code,
                        name: this.name,
                        phone_code: this.phone,
                        country_id: this.data.country_id ? this.data.country_id : 0,
                        city_id: this.data.country_id ? this.data.city_id : 0 
                    }
                     this.$refs.Addresses.validate().then(async (success) =>{
                        if(success){
                            switch(this.data.type){
                                case "country":
                                    switch(this.modalName){
                                        case "add":
                                            await this.$store.dispatch('addCountry', val)
                                            break;  
                                        case "edit":
                                            val.country_id = this.data.country_id
                                            await this.$store.dispatch('editCountry', val)
                                            break;  
                                    }
                                    break;
                                case "city":
                                    switch(this.modalName){
                                        case "add":
                                            await this.$store.dispatch('addCity', val)
                                            break;  
                                        case "edit":
                                            val.city_id = this.data.city_id
                                            await this.$store.dispatch('editCity', val)
                                            break;  
                                    }
                                    break;
                                case "town":
                                    switch(this.modalName){
                                        case "add":
                                            await this.$store.dispatch('addTown', val)
                                            break;  
                                        case "edit":
                                            val.town_id = this.data.town_id
                                            await this.$store.dispatch('editTown', val)
                                            break;  
                                    }
                                    break;
                            }
                            if(this.$store.getters.getAddressStatus.status == "Success"){
                                this.$store.dispatch('country_list')
                                this.$store.dispatch('city_list',val.country_id)
                                this.$store.dispatch('district_list',{city: val.city_id, country: val.country_id})
                                this.clearForm()
                            }else{
                                this.errMsg = i18n.t('customer.address.addErrMsg')
                            }
                        }
                     })
                }
                this.saveState(false)
            }
        }
    }
</script>

<style lang="css" scoped>
    @import "../styles/modal.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/Address.vue